import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form.tsx";
import {Checkbox} from "@/components/ui/checkbox.tsx";
import {useFormContext} from "react-hook-form";
import {z} from "zod";
import {BookingFormSchema} from "@/components/booking/form/BookingFormSchema.ts";
import {useContext} from "react";
import {OscarContext, OscarContextType} from "@/components/context/OscarContext.tsx";

export function TermsForm() {
    const {control} = useFormContext<z.infer<typeof BookingFormSchema>>();
    const { brandConfig, localConfig } = useContext(OscarContext) as OscarContextType

    return (
        <>
            { localConfig.communityBooking && (
                <div className={"os-text-orange-600 os-font-bold"}>Please note that your booking is not confirmed until {brandConfig?.name} has contacted you.</div>
            )}
            <div className={"os-mt-1.5"}>Please take a moment to review our <a className={"os-text-blue-500 hover:os-underline"} href={"https://aaskips.com.au/terms"} target={"_blank"}>Terms and Conditions & Additional Charges here</a>.</div>
            <FormField
                control={control}
                name="allowPromo"
                render={({ field }) => (
                    <FormItem className="os-flex os-flex-row os-items-center os-gap-2">
                        <FormControl className={"os-mt-1"}>
                            <Checkbox
                                checked={field.value}
                                onCheckedChange={field.onChange}
                            />
                        </FormControl>
                        <FormLabel>I’d like to receive promotions and special offers from us. (Generally around 3 messages a year).</FormLabel>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <FormField
                control={control}
                name="terms"
                render={({ field }) => (
                    <FormItem className="os-flex os-flex-row os-items-center os-gap-2">
                        <FormControl className={"os-mt-1"}>
                            <Checkbox
                                checked={field.value}
                                onCheckedChange={field.onChange}
                            />
                        </FormControl>
                        <FormLabel>I agree to {brandConfig?.name}'s <a className={"os-text-blue-500 hover:os-underline"} href={"https://aaskips.com.au/terms"} target={"_blank"}>Terms and Conditions</a>.</FormLabel>
                        <FormMessage />
                    </FormItem>
                )}
            />
        </>
    );
}